/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';
export const productDetailsThumbnailSliderSX =
	(slides: number): SxProps<Theme> =>
	(theme) => ({
		position: 'relative',
		textAlign: 'left',
		minWidth: theme.spacing(8),
		'.slide': {
			boxSizing: 'unset',
		},

		'div, button': {
			outline: 'none',
		},

		'.carousel__back-button, .carousel__next-button': {
			height: theme.spacing(5),
			width: theme.spacing(5),
			background: 'none',
			borderRadius: '50%',
			border: '1px solid transparent',

			'&:hover': {
				cursor: 'pointer',
				color: theme.palette.primary.main,
				borderColor: theme.palette.primary.light,
			},
		},

		'.carousel__inner-slide': {
			p: '1.5px',
			'.ribbon-ad': {
				[theme.breakpoints.up('md')]: {
					display: 'none',
				},
			},
		},

		[theme.breakpoints.down('md')]: {
			// maxHeight: theme.spacing(50),

			maxHeight: 'none',

			'.carousel__back-button, .carousel__next-button': {
				position: 'absolute',
				top: '50%',
				transform: 'translateY(-50%)',
			},

			'.carousel__back-button': {
				left: '0',
			},

			'.carousel__next-button': {
				right: 0,
			},

			'.carousel__dot-group': {
				position: 'absolute',
				left: '50%',
				transform: 'translateX(-50%)',
				bottom: theme.spacing(2.25),
				display: 'flex',
				justifyContent: 'center',
				width: '100%', // Asegura que el DotGroup ocupe todo el ancho disponible
				overflow: 'visible', // Evita que el contenido se corte
			},

			// '.carousel__dot': {
			// 	width: theme.spacing(2),
			// 	height: theme.spacing(2),
			// 	borderRadius: theme.spacing(1),
			// 	margin: theme.spacing(0.5),
			// 	border: `1px solid ${theme.palette.grey[300]}`,
			// 	backgroundColor: theme.palette.grey[300],
			// 	transition: `background-color ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeIn}`,

			// 	'&:hover': {
			// 		backgroundColor: theme.palette.secondary.light,
			// 	},

			// 	'&.carousel__dot--selected': {
			// 		backgroundColor: theme.palette.grey[200],
			// 		borderColor: theme.palette.grey[300],
			// 	},
			// },
			'.carousel__dot--selected': {
				backgroundColor: '#FFF !important',
				opacity: '1 !important',
			},

			'.carousel__dot--0': {
				borderRadius: slides > 1 ? '3px 0 0 3px' : '3px',
			},

			'.carousel__dot-group button:last-child': {
				borderRadius: slides > 1 ? '0 3px 3px 0' : '3px',
			},

			'.carousel__dot': {
				backgroundColor: '#000000',
				border: 'none',
				opacity: '0.3',
				width: `calc(170px/${slides})`,
				height: '6px',
				transition: `background-color ${theme.transitions.duration.standard}ms opacity 0.3 ${theme.transitions.easing.easeIn}`,
			},
		},
	});
